import { useEffect } from 'react';
import { useMatomo } from '@jonkoops/matomo-tracker-react';

import Header from 'components/Header';
import Footer from 'components/Footer';
import Intro from 'components/Intro/Intro';
import Contact from 'components/Contact';
import SplitInfo from 'components/SplitInfo';
import AlignedInfo from 'components/AlignedInfo';
import { alignedInfoContent, splitInfoContent } from './content';
import DownloadArea from 'components/DownloadArea';

const MainPage = () => {
  const { trackPageView } = useMatomo();

  useEffect(() => {
    trackPageView({
      documentTitle: 'Main Page',
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      <Header />
      <section id="intro">
        <Intro />
      </section>
      <section id="split-info">
        <SplitInfo data={splitInfoContent} />
      </section>
      <section id="aligned-info">
        <AlignedInfo data={alignedInfoContent} />
      </section>
      <section id="contact">
        <Contact />
      </section>
      <section id="download-area">
        <DownloadArea />
      </section>

      <Footer />
    </div>
  );
};

export default MainPage;
